import { AdminLayout } from '@app/ui/admin-layout/admin-layout';
import { AuthPage } from '@pages/auth-page/ui/auth-page';
import { ROUTE_ADMIN, ROUTE_AUTH, ROUTE_EMAIL_VERIFICATION } from '@shared/config/routes/routes';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { VerificationPage } from '@pages/verification-page/ui/verification-page';
import { useLayoutEffect } from 'react';
import { getCredentials } from '@shared/lib/utils/credentials/credentials';
import { UTMInfoKeysEnum } from '@entities/current-user/api/credentials-user-types';

export const AppRouter = () => {
    const { search } = useLocation();
    const history = useHistory();
    const credentials = getCredentials();

    const hasCredentials = credentials.accessToken || credentials.refreshToken;

    useLayoutEffect(() => {
        const searchParams = new URLSearchParams(search);
        for (const utmKey of Object.values(UTMInfoKeysEnum)) {
            const value = searchParams.get(utmKey);
            if (value) {
                localStorage.setItem(utmKey, value);
                searchParams.delete(utmKey);
            }
        }
        history.replace({
            search: searchParams.toString(),
        });
    }, [search]);

    return (
        <Switch>
            <Route path={ROUTE_AUTH} component={AuthPage} />
            <Route path={ROUTE_EMAIL_VERIFICATION} component={VerificationPage} exact />
            <Route path={ROUTE_ADMIN} component={AdminLayout} />
            <Redirect to={hasCredentials ? ROUTE_ADMIN : ROUTE_AUTH} />
        </Switch>
    );
};
